import { Component, HostListener, OnInit } from "@angular/core";

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  counter: number = 0;
  timer: any = null;
  route: "instrucciones" | "jugar" | "resultados" | "inicio" = "inicio";

  @HostListener("window:resize", ["$event"])
  onResize(_event: any) {
    this.setAppHeight();
  }

  private setAppHeight() {
    const doc = document.documentElement;
    const height = window.innerHeight;

    doc.style.setProperty("--app-height", `${height < 500 ? 500 : height}px`);
  }

  ngOnInit(): void {
    this.setAppHeight();
  }
}
